import axios from 'axios';
import { dataEnv } from "../../config/index.js";
const API_BASE_URL = dataEnv().API_URL;

export const getClientToken = (clientId) => {
  return axios.get(`${API_BASE_URL}/client/${clientId}/token`);
};

export const refreshClientToken = (clientId) => {
  return axios.post(`${API_BASE_URL}/client/${clientId}/refresh-token`);
}; 